import type { QuietHours } from './types.js';
import { inWindow, zonedParts } from './rules.js';

export const MIN_RING_INTERVAL_MINUTES = 5;
export const MAX_RING_DURATION_SECONDS = 120;

export function clampInterval(min: number): number {
  return Math.max(MIN_RING_INTERVAL_MINUTES, Math.min(24 * 60, Math.round(min)));
}

export function clampRingDuration(sec: number): number {
  return Math.max(3, Math.min(MAX_RING_DURATION_SECONDS, Math.round(sec)));
}

export function inQuietHours(q: QuietHours, at: Date, timeZone: string): boolean {
  if (!q.enabled) return false;
  return inWindow(zonedParts(at, timeZone).minutes, q.start, q.end);
}

/**
 * If `at` falls inside quiet hours, move it to the end of the quiet window (in the user's time zone).
 * Steps forward minute-granular in 5 minute increments — bounded, simple and DST-safe.
 */
export function deferPastQuietHours(q: QuietHours, at: Date, timeZone: string): Date {
  if (!inQuietHours(q, at, timeZone)) return at;
  let t = new Date(at.getTime());
  for (let i = 0; i < (24 * 60) / 5; i++) {
    t = new Date(t.getTime() + 5 * 60_000);
    if (!inQuietHours(q, t, timeZone)) return t;
  }
  return t;
}

/** Next ring time after a ring session at `from`. */
export function nextRingAfter(from: Date, intervalMinutes: number, q: QuietHours, timeZone: string): Date {
  return deferPastQuietHours(q, new Date(from.getTime() + clampInterval(intervalMinutes) * 60_000), timeZone);
}

/** Ringing lease length — a device must renew before this to keep responsibility for sound. */
export const RING_LEASE_SECONDS = 90;
